import { Splide } from "@splidejs/splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";

export function slide() {
  window.addEventListener('DOMContentLoaded', function () {

    // トップページ自動スライド

    if (document.querySelector(".js-slide-auto")) {
      var splideAuto = new Splide(".js-slide-auto", {
        type: "loop", // ループさせる
        arrows: false, // 矢印ボタンを非表示
        pagination: false, // ページネーションを非表示
        drag: "free", // フリードラッグモード
        gap: 20, // スライド間の余白
        perPage: 3, // 表示するスライドの枚数
        breakpoints: {
          500: {
            perPage: 1, // 画面幅500px未満で表示枚数1枚
            gap: 0, // 画面幅500px未満でスライド間の余白0
          },
        },
        autoScroll: {
          speed: 0.5, // スクロール速度
          pauseOnHover: false, // カーソルが乗ってもスクロールを停止させない
        },
      }).mount({ AutoScroll });
    }

    if (document.querySelector(".js-slide-auto-reverse")) {
      var splideAutoReverse = new Splide(".js-slide-auto-reverse", {
        type: "loop", // ループさせる
        arrows: false, // 矢印ボタンを非表示
        pagination: false, // ページネーションを非表示
        drag: "free", // フリードラッグモード
        gap: 20, // スライド間の余白
        perPage: 3, // 表示するスライドの枚数
        direction: "rtl", // スライドの方向を左から右
        breakpoints: {
          500: {
            perPage: 1, // 画面幅500px未満で表示枚数1枚
            gap: 0, // 画面幅500px未満でスライド間の余白0
          },
        },
        autoScroll: {
          speed: 0.5, // スクロール速度
          pauseOnHover: false, // カーソルが乗ってもスクロールを停止させない
        },
      }).mount({ AutoScroll });
    }

    // 客室詳細とenteatのスライド
    if (document.querySelector(".js-big-slide")) {
      const splide = new Splide(".js-big-slide", {
        type: "loop", // ループ
        speed: 1000, // スライダーの移動時間
        autoplay: true,
        interval: 3000,
        pauseOnHover: true,
        focus: 0,
        classes: {
          pagination: "splide__pagination big-slide-pagination",
          page: "splide__pagination__page your-class-page",
        },
      }).mount();
    }
    // ランチセクション
    if (document.querySelector(".js-small-slide-left")) {
      const splide = new Splide(".js-small-slide-left", {
        type: "loop", // ループ
        speed: 1000, // スライダーの移動時間
        autoplay: true,
        interval: 3000,
        pauseOnHover: true,
        focus: 0,
        classes: {
          pagination: "splide__pagination small-slide-pagination",
          page: "splide__pagination__page your-class-page",
        },
      }).mount();
    }
    if (document.querySelector(".js-small-slide-right")) {
      const splide = new Splide(".js-small-slide-right", {
        type: "loop", // ループ
        speed: 1000, // スライダーの移動時間
        autoplay: true,
        interval: 3000,
        pauseOnHover: true,
        focus: 0,
        classes: {
          pagination: "splide__pagination small-slide-pagination",
          page: "splide__pagination__page your-class-page",
        },
      }).mount();
    }
    if (document.querySelector(".js-mv-splide")) {
      const splide = new Splide(".js-mv-splide", {
        autoplay: true, // 自動再生
        type: "fade", // フェード
        rewind: true, // スライダーの終わりまで行ったら先頭に巻き戻す
        pauseOnHover: false, // カーソルが乗ってもスクロールを停止させない
        pauseOnFocus: false, // 矢印をクリックしてもスクロールを停止させない
        interval: 6000, // 自動再生の間隔
        speed: 7000, // スライダーの移動時間
      }).mount();
    }
  })
}
